module.exports = __webpack_public_path__ + "static/media/icon-elite-expert.3c06259c.svg";